import { KeyMetric } from '../enum';
import {
    prDocumentVisualizationsSeriesChartLabelsEngagement,
    prDocumentVisualizationsSeriesChartLabelsEstimatedViews,
    prDocumentVisualizationsSeriesChartLabelsLanguage,
    prDocumentVisualizationsSeriesChartLabelsLocationCountry,
    prDocumentVisualizationsSeriesChartLabelsNewsGuardScore,
    prDocumentVisualizationsSeriesChartLabelsReach,
    prDocumentVisualizationsSeriesChartLabelsSocialEcho
} from '../../translations';

export const KeyMetricTranslations = {
    [KeyMetric.engagement]: prDocumentVisualizationsSeriesChartLabelsEngagement,
    [KeyMetric.estimatedViews]: prDocumentVisualizationsSeriesChartLabelsEstimatedViews,
    [KeyMetric.language]: prDocumentVisualizationsSeriesChartLabelsLanguage,
    [KeyMetric.locationCountry]: prDocumentVisualizationsSeriesChartLabelsLocationCountry,
    [KeyMetric.newsGuardScore]: prDocumentVisualizationsSeriesChartLabelsNewsGuardScore,
    [KeyMetric.reach]: prDocumentVisualizationsSeriesChartLabelsReach,
    [KeyMetric.socialEcho]: prDocumentVisualizationsSeriesChartLabelsSocialEcho
};

